import type { NavSection } from './config';
import NavSectionButton from './NavSectionButton';
import NavSectionInert from './NavSectionInert';
import type { SectionBadge } from './section-badge';
import type { NavFlyoutApi } from './useNavFlyout';

interface NavSectionTriggerProps {
  section: NavSection;
  /** Icon-only, for the rail; otherwise the labelled row. */
  collapsed: boolean;
  /** The section the current route is in. */
  active: boolean;
  open: boolean;
  flyoutId: string;
  flyout: NavFlyoutApi;
  /** What the heading says about its pages' badges: the dot, and its name. */
  badge: SectionBadge;
}

/** One section row, in either band: inert while unbuilt, otherwise the button
 *  that opens its fly-out. */
export default function NavSectionTrigger({
  section,
  collapsed,
  active,
  open,
  flyoutId,
  flyout,
  badge,
}: NavSectionTriggerProps) {
  if (!section.ready) return <NavSectionInert section={section} collapsed={collapsed} />;

  return (
    <NavSectionButton
      section={section}
      collapsed={collapsed}
      active={active}
      open={open}
      flyoutId={flyoutId}
      flyout={flyout}
      badge={badge}
    />
  );
}
